export default __webpack_public_path__ + "764245917becbc418ef346659a838907.png";